// extracted by mini-css-extract-plugin
module.exports = {"arc-group-button":"Group_arc-group-button__1Q7pZ"};